module.exports = __webpack_public_path__ + "static/media/stork-illustration.8eb35363.png";